import { apiRequest } from './apiClient'

// Список тикетів підтримки з фільтром по статусу та пагінацією
export function fetchSupportTickets(status = 'active', limit = 20, offset = 0) {
  return apiRequest(`/support/tickets?status=${status}&limit=${limit}&offset=${offset}`)
}

// Лічильники тикетів для вкладок
export function fetchSupportTicketCounts() {
  return apiRequest('/support/tickets/counts')
}

// Один тикет з усіма деталями
export function fetchSupportTicket(id) {
  return apiRequest(`/support/tickets/${id}`)
}

// Створення нового тикету підтримки
export function createSupportTicket({ subject, message, language }) {
  return apiRequest('/support/tickets', {
    method: 'POST',
    body: JSON.stringify({ subject, message, language }),
  })
}

// Список повідомлень тикету з пагінацією
export function fetchSupportMessages(ticketId, limit = 50, offset = 0) {
  return apiRequest(`/support/tickets/${ticketId}/messages?limit=${limit}&offset=${offset}`)
}

// Надсилання повідомлення в тикет
export function sendSupportMessage(ticketId, content) {
  return apiRequest(`/support/tickets/${ticketId}/messages`, {
    method: 'POST',
    body: JSON.stringify({ content }),
  })
}

// Ескалація тикету до оператора
export function escalateTicket(ticketId) {
  return apiRequest(`/support/tickets/${ticketId}/escalate`, { method: 'POST' })
}

// Закрити тикет як вирішений
export function resolveTicket(ticketId) {
  return apiRequest(`/support/tickets/${ticketId}/resolve`, { method: 'POST' })
}

// Позначити тикет як прочитаний
export function markTicketRead(ticketId) {
  return apiRequest(`/support/tickets/${ticketId}/read`, { method: 'POST' })
}

// Кількість непрочитаних повідомлень підтримки
export function fetchUnreadCount() {
  return apiRequest('/support/unread-count')
}

// Завантаження файлу-вкладення до тикету підтримки
export function uploadSupportAttachment(ticketId, file) {
  const form = new FormData()
  form.append('file', file)
  return apiRequest(`/support/tickets/${ticketId}/attachments`, {
    method: 'POST',
    body: form,
  })
}

// Перевірка чи увімкнений чат підтримки для поточного дилера
export function fetchSupportStatus() {
  return apiRequest('/support/status')
}
